function updateVh () {
  const vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh', `${vh}px`)
}

export default function initVhCssVariable () {
  const initalvh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--initial-vh', `${initalvh}px`)
  window.addEventListener('resize', () => {
    updateVh()
  })
  updateVh()
}
